import { AddOnVendors } from '@/types/addons';
import { apiVendorMap } from '@/types/addons';
import { useAppSelector } from '@/redux/store';

export const useOrganizationHasISVAddOns = () => {
  const loggedUser = useAppSelector(state => state.loggedUser);
  return loggedUser?.organizationAddOns?.some(
    addOn =>
      apiVendorMap[addOn.vendor] === AddOnVendors.ThreatDown ||
      apiVendorMap[addOn.vendor] === AddOnVendors.CheckPointHarmonySASE ||
      apiVendorMap[addOn.vendor] === AddOnVendors.CheckPointHarmonyEC
  );
};
